const IP_URL = process.env.REACT_APP_NODE_API_URL

export const getSettingsModulesByID = async (applicationId, userId, moduleId) => {
    try {
        const response = await fetch(IP_URL + "api_settings/settings_module_by_id", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ applicationId, userId,  moduleId}),
      });
      const data = await response.json();
      return data;
    } catch (error) {
      //console.error("Error al iniciar sesión", error);
      var aux = 0;
    }
  };